export function getContainerWidth(elem: HTMLElement): number {
  return elem.offsetWidth !== 0 ? elem.offsetWidth : window.innerWidth
}

export function getContainerHeight(elem: HTMLElement): number {
  return elem.offsetHeight !== 0 ? elem.offsetHeight : window.innerHeight
}
